<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="XIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="openCancelImportation" v-show="isPosted"   />
    </div>
</template>

<script>
export default {
  name: 'CellMuckActions',
  computed: {
    isPosted() {
      return this.params.data.isPosted;
    }
  },
  methods: {
    openCancelImportation() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: name,
        text: this.$t('GradeControl.Posting.ConfirmCancelPosting'),
        accept: this.cancelPosting
      });
    },

    cancelPosting () {
      this.params.context.componentParent.cancelPosting(this.params.data);
    }
  }
}
</script>
